import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { OpenInNewOutlined } from '@mui/icons-material';
import { ConsentNotesDetails } from "~/components/BillingEligibility/ConsentNotesDetails";
const truncateText = (text, maxLength = 50) => {
    if (!text)
        return "-";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};
export const ConsentLogHistoryLayout = (props) => {
    const [isNotesOpen, setIsNotesOpen] = useState(false);
    const [noteDetails, setNoteDetails] = useState('');
    return (React.createElement("div", { style: { display: 'grid', minHeight: '200px', height: '100%', width: '100%', alignContent: 'center' } },
        React.createElement("div", { style: { textAlign: 'center', color: '#000000DE', fontFamily: 'Barlow', fontWeight: 700, width: '100%', marginLeft: 'auto', marginRight: 'auto' } }, "Consent Log"),
        React.createElement("br", null),
        React.createElement(TableContainer, { component: Paper, sx: { border: '1px solid #ccc', borderRadius: '8px', overflow: 'hidden' } },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, { sx: { backgroundColor: '#f5f5f5' } },
                        React.createElement(TableCell, null,
                            React.createElement("b", null, "Date & Time")),
                        React.createElement(TableCell, null,
                            React.createElement("b", null, "Program")),
                        React.createElement(TableCell, null,
                            React.createElement("b", null, "Action")),
                        React.createElement(TableCell, null,
                            React.createElement("b", null, "User")),
                        React.createElement(TableCell, null,
                            React.createElement("b", null, "Consent Method")),
                        React.createElement(TableCell, null,
                            React.createElement("b", null, "Opt Out Reason")),
                        React.createElement(TableCell, null,
                            React.createElement("b", null, "Notes")),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, props.consentLogs.map((log, index) => (React.createElement(TableRow, { key: index, sx: { borderBottom: '1px solid #ddd' } },
                    React.createElement(TableCell, null, log.dateTime),
                    React.createElement(TableCell, null, log.program),
                    React.createElement(TableCell, null, log.program == 'CGM' ? (log.action == 'Opt In' ? 'Activated' : log.action == 'Opt Out' ? 'Deactivated' : log.action) : log.action),
                    React.createElement(TableCell, null, log.userName),
                    React.createElement(TableCell, null, log.consentMethod ? log.consentMethod : '-'),
                    React.createElement(TableCell, null, log.optOutReason ? log.optOutReason : '-'),
                    React.createElement(TableCell, null, truncateText(log.notes, 10)),
                    React.createElement(TableCell, null,
                        React.createElement(OpenInNewOutlined, { onClick: () => { setNoteDetails(log.notes); setIsNotesOpen(true); } })))))))),
        isNotesOpen && React.createElement(ConsentNotesDetails, { notes: noteDetails, onClose: () => { setIsNotesOpen(false); setNoteDetails(''); } })));
};
